import React from 'react'

import Header from './sections/Header'
import Page from '../../../../components/pdf/Page'

import PgrTable from './sections/00.PgrTable'

const PdfDocument = ({ serviceOrder, validity }) => {
  return (
    <Page header={<Header />}>
      <PgrTable serviceOrder={serviceOrder} validity={validity} />
    </Page>
  )
}

export default PdfDocument
